<template>
    <PageFrameContainer>
        <div class="main-container">
            <div class="info-panel">
                <img class="logo" src="../../../assets/icons/logo_power.svg" alt="start">
                <div class="tabs">
                    <input id="tab1" type="radio" name="tabs" checked>
                    <label for="tab1">{{$t('pages.pricing.learnMore.power.description.title')}}</label>
                    <input id="tab2" type="radio" name="tabs">
                    <label for="tab2">{{$t('pages.pricing.learnMore.power.specification.title')}}</label>

                    <div class="content">
                        <div id="content1">
                            <p>
                                {{$t('pages.pricing.learnMore.power.description.text')}}
                            </p>
                            <ul>
                                <li v-for="(i,index) in $t('pages.pricing.learnMore.power.description.functions')"
                                    :key="index">{{i}}
                                </li>
                            </ul>
                            <p>
                                <i>{{$t('pages.pricing.learnMore.power.description.delivery.deliveryItalic')}}</i> {{$t('pages.pricing.learnMore.power.description.delivery.electronicKey')}}
                            </p>
                        </div>

                        <div id="content2">
                            <h4>
                                {{$t('pages.pricing.learnMore.power.specification.text')}}
                            </h4>
                            <div class="spec-table">
                                <p>
                                    {{$t('pages.pricing.learnMore.power.specification.table.min')}}
                                </p>
                                <p>
                                    {{$t('pages.pricing.learnMore.power.specification.table.processor')}}
                                </p>
                                <div class="versions-track"></div>
                                <p>
                                    {{$t('pages.pricing.learnMore.power.specification.table.operating')}}
                                </p>
                                <p>
                                    {{$t('pages.pricing.learnMore.power.specification.table.win')}}
                                </p>
                                <div class="versions-track"></div>
                                <p>
                                    {{$t('pages.pricing.learnMore.power.specification.table.supportVideo')}}
                                </p>
                                <p>
                                    {{$t('pages.pricing.learnMore.power.specification.table.videoFormats')}}
                                </p>
                                <div class="versions-track"></div>
                                <p>
                                    {{$t('pages.pricing.learnMore.power.specification.table.supportImage')}}
                                </p>
                                <p>
                                    {{$t('pages.pricing.learnMore.power.specification.table.imageFormats')}}
                                </p>
                                <div class="versions-track"></div>
                                <p>
                                    {{$t('pages.pricing.learnMore.power.specification.table.supportHtml')}}
                                </p>
                                <p>
                                    {{$t('pages.pricing.learnMore.power.specification.table.htmlFormats')}}
                                </p>
                                <div class="versions-track"></div>
                                <p>
                                    {{$t('pages.pricing.learnMore.power.specification.table.supportSlides')}}
                                </p>
                                <p>
                                    {{$t('pages.pricing.learnMore.power.specification.table.slidesFormats')}}
                                </p>
                                <div class="versions-track"></div>
                                <p>
                                    {{$t('pages.pricing.learnMore.power.specification.table.supportLocal')}}
                                </p>
                                <p>
                                    {{$t('pages.pricing.learnMore.power.specification.table.localFormats')}}
                                </p>
                                <div class="versions-track"></div>
                                <p>
                                    {{$t('pages.pricing.learnMore.power.specification.table.supportCloud')}}
                                </p>
                                <p>
                                    {{$t('pages.pricing.learnMore.power.specification.table.cloudFormats')}}
                                </p>
                                <div class="versions-track"></div>
                                <p>
                                    {{$t('pages.pricing.learnMore.power.specification.table.supportApp')}}
                                </p>
                                <p>
                                    {{$t('pages.pricing.learnMore.power.specification.table.appFormats')}}
                                </p>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
            <div class="add-to-cart-pannel">
                <div class="cart-info">
                    <h1>{{$t('pages.pricing.learnMore.power.addCartPanel.title')}}</h1>
                    <p>
                        <b>{{$t('pages.pricing.learnMore.power.addCartPanel.product')}}</b> {{$t('pages.pricing.learnMore.power.addCartPanel.key')}}
                    </p>
                    <h4>
                        <b>{{$t('pages.pricing.learnMore.power.addCartPanel.plan')}}</b> $456.00
                    </h4>
                </div>
                <div class="available-opts" v-if="$features.productStoreExtraOptions">
                    <h3>{{$t('pages.pricing.learnMore.power.addCartPanel.availableOpts.title')}}</h3>
                    <p>
                        {{$t('pages.pricing.learnMore.power.addCartPanel.availableOpts.remote')}}
                    </p>
                    <div class="tabs-available-opts">
                        <input id="tab1-available" type="radio" name="tabs-available-opts" checked>
                        <label for="tab1-available">{{$t('pages.pricing.learnMore.power.addCartPanel.availableOpts.order')}} (+$45.00)</label>
                        <input id="tab2-available" type="radio" name="tabs-available-opts">
                        <label for="tab2-available">{{$t('pages.pricing.learnMore.power.addCartPanel.availableOpts.myself')}}</label>
                    </div>
                </div>
                <button v-on:click="addToCart">
                    {{$t('pages.pricing.learnMore.power.addCartPanel.addToCart')}}
                </button>
            </div>
        </div>
    </PageFrameContainer>
</template>

<script>
    import PageFrameContainer from "../../../components/PageFrameContainer";

    export default {
        name: "PlayerPowerInfoPage",
        components: {PageFrameContainer},
        props: ['productId'],
        methods: {
            addToCart() {
                console.info(`add to cart: ${this.productId}, 1`);
                this.$store.commit('addToCart', {product: this.productId, qty: 1});
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../theme/theme";

    .main-container {
        display: grid;
        grid-template: 'info cart';
        grid-template-columns: 2fr 1fr;
        grid-template-rows: auto;
        font-weight: 300;


        .info-panel {
            grid-area: info;
            display: grid;
            grid-template-rows: auto auto;
            margin-bottom: 2rem;

            .logo {
                grid-row: 1;
                justify-self: center;
            }


            .tabs {
                grid-row: 2;
                max-width: 800px;
                margin-top: 20px;
                padding: 0 20px;
                justify-self: left;

                input {
                    display: none;
                }

                label {
                    display: inline-block;
                    padding: 0.5rem 1rem 0.5rem 1rem;
                    // width: 25%; /* =100/tabs number */
                    border-bottom: 1px solid $text40;
                    text-align: center;
                    color: $primary80;
                }

                label:hover {
                    cursor: pointer;
                    //background: $back60;

                }

                input:checked + label {
                    border: 1px solid $text40;
                    border-width: 1px 1px 0 1px;
                    color: $text80;
                }

                #tab1:checked ~ .content #content1,
                #tab2:checked ~ .content #content2 {
                    display: block;
                }

                .content > div {
                    display: none;
                    padding-top: 20px;
                    text-align: left;
                    /*height: 192px;*/
                    overflow: auto;
                }

                h4 {
                    font-weight: 400;
                }

                ul {
                    padding-left: 1rem;
                    padding-right: 1rem;
                    margin-left: 0.5em;
                    margin-top: 0.5em;
                    padding-bottom: 0.2em;
                    margin-bottom: 0.2em;
                    color: $text80;
                    font-size: 0.8rem;

                    li {
                        margin-top: 0.2em;
                        margin-bottom: 1em;
                    }
                }

                p {
                    // padding-left: 1rem;
                    padding-right: 1rem;
                    font-size: 1rem;
                    color: $text80;
                    margin-bottom: 0.2em;
                    font-weight: 400;
                }

                .spec-table {
                    display: grid;
                    margin-top: 0.5rem;
                    grid-template-columns: 1fr 2fr;
                    border: 1px solid $text40;

                    p {
                        padding-left: 0.5rem;
                        padding-top: 0.5rem;
                        font-size: 0.9rem;
                        font-weight: 300;
                    }

                    .versions-track {
                        margin-bottom: 0;
                        border-bottom: 1px solid $text20;
                        z-index: -1;
                        grid-column-start: 1;
                        grid-column-end: 3;
                    }
                }
            }
        }

        .add-to-cart-pannel {
            grid-area: cart;
            display: grid;
            align-self: start;
            grid-template-rows: auto auto auto;
            grid-row-gap: 1rem;
            margin-top: 2rem;

            .cart-info {
                grid-row: 1;
                align-self: center;
                justify-self: left;
            }

            h1 {
                font-weight: 400;
                font-size: 2.2rem;
                padding-bottom: 1rem;
            }

            p {
                font-weight: 300;
                padding-bottom: 1rem;
            }

            h4 {
                font-weight: 300;
                font-size: 1.2rem;
            }

            .available-opts {
                grid-row: 2;
                justify-self: center;

                h3 {
                    margin-bottom: 1rem;
                }

                .tabs-available-opts {
                    display: grid;
                    grid-template-columns: auto auto;
                    grid-template-rows: auto auto;
                    align-items: start;
                    row-gap: 2rem;
                    font-size: 0.8rem;

                    input {
                        align-self: center;
                        margin-right: 0.5rem;
                    }
                }

            }

            button {
                grid-row: 3;
                padding: 0.7em 2em;
                margin-bottom: 1rem;
                background: $primary100;
                border: 0;
                text-decoration: none;
                border-radius: 0.4rem;
                text-effect: none;
                font-size: 1em;
                align-self: center;
                justify-self: normal;
                cursor: pointer;
                color: $primaryText100;
                transition: all .25s;
                outline: none;
            }

            button:hover {
                background: $primary40;
            }
        }
    }


    @media (max-width: 60em) {
        .main-container {
            grid-template: 'info' 'cart';
            grid-template-columns: auto;
            grid-template-rows: auto auto;
        }


    }
</style>